import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import islandNavMovil from '../../images/svgs/islands/islaNavMovil.svg';
import islandNavDesktop from '../../images/svgs/islands/islandNavDesktop.svg';
import island1 from '../../images/svgs/islands/island1.svg';
import island3 from '../../images/svgs/islands/island3.svg';
import island3r from '../../images/svgs/islands/island3r.svg';
import island4 from '../../images/svgs/islands/island4.svg';
import island4r from '../../images/svgs/islands/island4r.svg';
import island5 from '../../images/svgs/islands/island5.svg';
import island6 from '../../images/svgs/islands/island6.svg';
import island2 from '../../images/svgs/islands/island2.svg';

import { breakpoints } from '../../constants/styles';

const LighthouseDesktop = 'https://s3.us-east-2.amazonaws.com/finauta/art/onlyLighthouse.png';
const sand = 'https://s3.us-east-2.amazonaws.com/finauta/art/sand.png';

const islandTypes = {
  nav: css`
    position: absolute;
    width: 100%;
    background-repeat: no-repeat;
    z-index: -1;
    height: 125px;
    background-image: url(${islandNavMovil});
    background-size: 426px 221px;
    background-position: calc(100% + 260px) 0px;
    top: 0px;
    right: -10px;
    transform: rotateZ(0deg);

    ${breakpoints.mobileLandscape} {
      background-position: calc(100% + 190px) 0px;
    }

    ${breakpoints.tablet} {
      background-position: calc(100% + 60px) 0px;
      height: 195px;
      background-size: 556px 181px;
    }

    ${breakpoints.tabletLandscape} {
      background-position: calc(100% + 60px) 0px;
      height: 255px;
      background-size: 556px 281px;
    }

    ${breakpoints.desktop} {
      height: 470px;
      background-image: url(${islandNavDesktop});
      background-size: 890px;
      background-position: right 0;
      top: -40px;
      right: -115px;
    }
  `,
  first3: css`
    display: none;
    ${breakpoints.tabletLandscape} {
      display: block;
      background-image: url(${island1});
      top: -200px;
      left: -340px;
      background-size: 620px;
      height: 620px;
    }

    ${breakpoints.desktop} {
      background-size: 680px;
      height: 680px;
    }
  `,
  first2: css`
    background-image: url(${island1});
    height: 360px;
    min-height: 360px;
    top: 50px;
    background-size: 360px 360px;
    background-position: calc(100% + 260px) 0px;
    top: 400px;

    ${breakpoints.mobileLandscape} {
      top: 420px;
    }

    ${breakpoints.tablet} {
      top: 400px;
      background-position: calc(100% + 220px) 0px;
    }

    ${breakpoints.tabletLandscape} {
      display: none;
    }
  `,
  last: css`
    z-index: -10;
    background-image: url(${island2});
    min-height: 1000px;
    height: 1000px;
    background-size: 1500px 400px;
    background-position: -955px 80px;
    top: 3900px;

    ${breakpoints.tablet} {
      left: -410px;
      top: 50px;
      height: 330px;
      background-size: 529px 280px;
      background-position: 0px;
    }

    ${breakpoints.tabletLandscape} {
      left: -590px;
      top: 120px;
      background-size: 769px 560px;
    }

    ${breakpoints.larger} {
      left: -900px;
      top: 260px;
      background-size: 1139px 620px;
    }
  `,
  first: css`
    background-image: url(${island1});
    height: 470px;
    background-size: 1500px 400px;
    background-position: -815px 80px;
    top: -250px;

    ${breakpoints.tablet} {
      height: 530px;
      background-size: 1500px 470px;
    }

    ${breakpoints.tabletLandscape} {
      display: none;
    }
  `,
  second2: css`
    background-image: url(${island3r});
    height: 365px;
    background-size: 318px 225px;
    background-position: 0px 0px;
    top: -62px;
    left: -190px;

    ${breakpoints.mobileLandscape} {
    }

    ${breakpoints.tablet} {
      height: 365px;
      background-size: 438px 325px;
      top: -100px;
      left: -240px;
    }

    ${breakpoints.tabletLandscape} {
      height: 555px;
      background-size: 518px 555px;
      top: -250px;
      left: -290px;
    }

    ${breakpoints.larger} {
      background-size: 788px 575px;
      top: -205px;
      left: -430px;
    }
  `,

  second: css`
    background-image: url(${island3});
    height: 355px;
    min-height: 355px;

    background-size: 318px 355px;
    background-position: calc(100% + 180px) center;
    top: -60px;

    ${breakpoints.desktop} {
      height: 546px;
      top: 2690px;
      background-size: 489px 546px;
      background-position: calc(100% + 195px) center;
    }

    ${breakpoints.desktop2} {
      top: 2360px;
    }

    ${breakpoints.larger} {
    }
  `,
  third: css`
    background-image: url(${island4r});
    min-height: 261px;
    height: 261px;
    background-size: 647px 231px;
    background-position: calc(100% + 180px) center;
    top: -100px;
    left: 193px;

    ${breakpoints.mobileLandscape} {
    }

    ${breakpoints.tablet} {
      height: 311px;
      background-size: 770px 321px;
      top: -220px;
      left: 243px;
    }

    ${breakpoints.tabletLandscape} {
      height: 450px;
      background-size: 870px 391px;
      top: -290px;
      left: 293px;
    }

    ${breakpoints.larger} {
      height: 540px;
      background-size: 830px 541px;
      top: -330px;
      left: 293px;
    }
  `,
  fourth: css`
    background-image: url(${island5});
    display: none;
    min-height: 826px;
    background-position: calc(100% + 395px) center;

    ${breakpoints.tabletLandscape} {
      display: block;
      background-size: 640px;
      height: 826px;
      top: 70px;
      left: 110px;
    }

    ${breakpoints.desktop} {
    }

    ${breakpoints.larger} {
      height: 826px;
      top: 120px;
      left: 10px;
    }
  `,
  fourth2: css`
    background-image: url(${island5});
    min-height: 326px;
    height: 326px;
    background-size: 421px 326px;
    background-position: -255px 0px;
    top: -130px;
    ${breakpoints.desktop} {
      display: none;
    }
  `,
  fourth3: css`
    background-image: url(${island5});
    min-height: 326px;
    height: 326px;
    background-size: 421px 326px;
    background-position: calc(100% + 280px) center;
    top: 120px;
    ${breakpoints.mobileLandscape} {
      top: 215px;
    }

    ${breakpoints.tabletLandscape} {
      height: 626px;
      background-size: 841px 556px;
      background-position: calc(100% + 490px) center;
    }
  `,
  sixth: css`
    background-image: url(${island6});
    display: none;
    min-height: 1000px;

    ${breakpoints.tabletLandscape} {
      display: block;
      background-size: 1380px 370px;
      background-position: -837px 0px;
      top: 65vh;
    }

    ${breakpoints.desktop} {
      background-position: -737px 80px;
      top: 50vh;
    }
  `,
  lighthouseSand: css`
    position: relative;
    height: 470px;
    // background-image: url(${sand});
    // background-repeat: repeat; 
    // background-cover: none;
    // background-size: 607px 312px;

    ${breakpoints.mobileLandscape} {
      height: 500px;
    }
  `,
  lighthouse: css`
    position: relative;
    display: block;
    height: 390px;
    background-size: cover;
    background-image: url(${LighthouseDesktop});
    left: -35px;
    min-width: 620px;
    max-width: 620px;
  `,
  firstToolLanding: css`
    background-image: url(${island5});
    height: 326px;
    background-size: 421px 326px;
    transform: rotateX(180deg);
    background-position: -260px;
    top: -160px;

    ${breakpoints.tablet} {
      height: 416px;
      background-size: 471px 406px;
      background-position: -240px;
      top: -220px;
    }

    ${breakpoints.desktop} {
      height: 486px;
      background-size: 581px 496px;
      background-position: -270px;
      top: -310px;
    }
  `,
  secondToolLanding: css`
    background-image: url(${island3});
    height: 255px;
    background-size: 198px 295px;
    background-position: calc(100% + 125px) center;
    top: -79px;

    ${breakpoints.tablet} {
      background-position: calc(100% + 85px) center;
      top: -59px;
    }

    ${breakpoints.desktop} {
      height: 385px;
      background-size: 278px 405px;
      background-position: calc(100% + 115px) center;
      top: -99px;
    }
  `,

  thirdToolLanding: css`
    background-image: url(${island4});
    height: 171px;
    background-size: 577px 141px;
    transform: rotateZ(0deg);
    background-position: -320px;
    top: -120px;

    ${breakpoints.tablet} {
      height: 211px;
      background-size: 657px 191px;
      background-position: -370px;
      top: -140px;
    }

    ${breakpoints.desktop} {
      height: 301px;
      background-size: 747px 311px;
      background-position: -370px;
      top: -110px;
    }
  `,
  referalLanding: css`
    background-image: url(${island5});
    height: 326px;
    background-size: 421px 326px;
    transform: rotateX(180deg);
    background-position: -300px;
    top: -210px;

    ${breakpoints.mobileLandscape} {
      background-position: -290px;
      top: -190px;
    }

    ${breakpoints.tabletLandscape} {
      height: 416px;
      background-size: 471px 406px;
      background-position: -310px;
      top: -340px;
    }

    ${breakpoints.desktop} {
      height: 526px;
      background-size: 521px 526px;
      background-position: -330px;
      top: -370px;
    }
  `,
};

const StyledIsland = styled.div`
  position: absolute;
  width: 100%;

  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-size: cover;
  z-index: -1;

  ${({ styles }) => styles}
  ${({ type }) => islandTypes[type]}
`;

const Island = ({ src, styles, type }) => <StyledIsland src={src} type={type} styles={styles} />;

Island.propTypes = {
  src: PropTypes.string,
  type: PropTypes.string,
  styles: PropTypes.array,
};

Island.defaultProps = {
  src: '',
  type: '',
  styles: [],
};

export default Island;
